<div class="create-dashboard-modal">
  <p class="modal-intro">
    <ng-container *ngIf="cloneMode; else addDashboardIntro">
      Clone <strong>{{ modalConfig.data?.sourceDashboardDisplay }}</strong> into
      <strong>{{ modalConfig.data?.groupDisplay }}</strong>.
      The complete dashboard design is copied; saved user views are not.
    </ng-container>
    <ng-template #addDashboardIntro>
      Add a dashboard to <strong>{{ modalConfig.data?.groupDisplay }}</strong>.
    </ng-template>
    <ng-container *ngIf="!simpleMode">Data access remains enforced by the server.</ng-container>
  </p>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="modal-form-grid">
    <label [class.full-width]="simpleMode">
      <span>{{ simpleMode ? 'Name' : 'Tab name' }}</span>
      <input class="form-control" [(ngModel)]="model.tabDisplay"
        (ngModelChange)="onTabDisplayChanged($event)" placeholder="Training Performance" />
    </label>

    <label *ngIf="!simpleMode">
      <span>Dashboard key</span>
      <input class="form-control" [(ngModel)]="model.dashboardKey"
        (input)="markKeyEdited()" placeholder="training-performance" />
      <small>Stable configuration key; lowercase letters, numbers, and hyphens.</small>
    </label>

    <label *ngIf="!simpleMode">
      <span>Dashboard display</span>
      <input class="form-control" [(ngModel)]="model.dashboardDisplay"
        (input)="markDisplayEdited()" />
      <small>Used in the designer configuration list.</small>
    </label>

    <label *ngIf="!simpleMode">
      <span>Page title</span>
      <input class="form-control" [(ngModel)]="model.title" (input)="markTitleEdited()" />
    </label>

    <label [class.full-width]="simpleMode">
      <span>Description</span>
      <textarea class="form-control" rows="3" [(ngModel)]="model.description"></textarea>
    </label>

    <label [class.full-width]="simpleMode">
      <span>Icon class</span>
      <input class="form-control" [(ngModel)]="model.iconClass" placeholder="fa fa-bar-chart" />
    </label>

    <label *ngIf="!simpleMode">
      <span>Default data source</span>
      <input class="form-control" [(ngModel)]="model.dataSourceItemName" placeholder="roCheckrideFactBase" />
    </label>

    <label *ngIf="!simpleMode" class="active-option full-width">
      <input type="checkbox" [(ngModel)]="model.isActive" />
      <span>Active</span>
    </label>
  </div>
</div>
